import type { GetAppointmentsLog, GetShiftsLog } from "@/server-types";
import { get } from "../request-helpers";
import { useCustomQuery } from "../custom-query";

/**
 * GET /log/appointments
 */
export const useAppointmentsLog = (
  query: GetAppointmentsLog["query"],
  options?: { enabled?: boolean },
) => {
  return useCustomQuery({
    queryKey: ["getAppointmentLog", query],
    queryFn: () => get<GetAppointmentsLog>("/log/appointments", query),
    enabled: options?.enabled,
  });
};

/**
 * GET /log/shifts
 */
export const useShiftsLog = (
  query: GetShiftsLog["query"],
  options?: { enabled?: boolean },
) => {
  return useCustomQuery({
    queryKey: ["getShiftsLog", query],
    queryFn: () => get<GetShiftsLog>("/log/shifts", query),
    enabled: options?.enabled,
  });
};
